import { createContext, useContext } from 'react'

const CanonicalUrlContext = createContext<string>('')

export type CanonicalUrlProviderProps = {
  children: React.ReactNode
  canonicalUrl?: string
}

export function CanonicalUrlProvider({
  children,
  canonicalUrl = '',
}: CanonicalUrlProviderProps) {
  return (
    <CanonicalUrlContext.Provider value={canonicalUrl}>
      {children}
    </CanonicalUrlContext.Provider>
  )
}

export const useCanonicalUrl = () => useContext(CanonicalUrlContext)
